const DELTA_THRESHOLD = 5;
const TOP_GUARD_PX = 80;

export function bindScrollHide(navbar: HTMLElement | null, footer: HTMLElement | null): void {
    let lastY = window.scrollY;

    window.addEventListener(
        "scroll",
        () => {
            const currentY = window.scrollY;
            const delta = currentY - lastY;

            if (Math.abs(delta) < DELTA_THRESHOLD) return;

            if (currentY <= 0) {
                navbar?.classList.remove("is-scroll-hidden");
                footer?.classList.remove("is-scroll-hidden");
                lastY = 0;
                return;
            }

            const scrollingDown = delta > 0;
            const nearTop = currentY <= TOP_GUARD_PX;

            navbar?.classList.toggle("is-scroll-hidden", scrollingDown && !nearTop);
            footer?.classList.toggle("is-scroll-hidden", scrollingDown);

            lastY = currentY;
        },
        { passive: true },
    );
}
